<template>
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else>
    <!-- <pdf-viewer
      fileUrl="http://localhost:3010/api/v0.1/content/pdfUploads/-xD1kgSCG1sVpDZmHGUbAg/rpV6gVzCTG53hED4XwgE7w.pdf"
      :signAreaList="[]" /> -->
    <pdf-viewer
      :docsInstKey="docsInstKey"
      :fileUrl="formData.pdfDocFileUrl"
      :signAreaList="formData.signAreaList" />
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import PdfViewer from './PdfViewer'

export default {
  name: 'sign-doc',
  version: '0.0.1',
  props: {
    docsInstKey: {
      type: String,
      required: true
    }, // docsInstKey
    contentInstKey: {
      type: String,
      required: true
    }, // contentInstKey
    contentKey: {
      type: String,
      required: true
    } // contentKey
  }, // props
  components: {
    PdfViewer
  }, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      formData: {
        pdfDocFileUrl: null,
        signAreaList: []
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted () {
    this.loaded = false
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)

      console.log('TRACE-REMOVE: SignDoc.mounted: resp is: ', resp)
      const _contentData = resp.data.payload.content
      this.formData.pdfDocFileUrl = config.glapiBaseUri + '/content/pdfUploads/' +
        this.contentInstKey + '/' + _contentData.fragments.pdfFileKey + '.pdf'
      this.formData.signAreaList = _contentData.fragments.signAreaList

      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
</style>
